import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'src/app/shared/components/molecules/snackbar/snackbar.component';
import { SnackBarStatus } from 'src/app/shared/models/constants/snackbar-status';
import { oneSecond } from 'src/app/utils/time';

@Injectable({
  providedIn: 'root',
})
/**
 * Knows how to open snackbars
 */
export class SnackBarService {
  /**
   * @constructor
   */
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly zone: NgZone
  ) {}

  /**
   * opens a snackbar
   * @param {SnackBarStatus} status
   * @param {string} message
   */
  private open(status: SnackBarStatus, message: string) {
    this.zone.run(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {
        duration: 3 * oneSecond,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        data: {
          message: message,
          status: status,
        },
        panelClass: ['snackbar-component'],
      });
    });
  }

  /**
   * opens a success snackbar
   * @param {string} message
   */
  success(message: string) {
    this.open(SnackBarStatus.SUCCESS, message);
  }

  /**
   * opens an info snackbar
   * @param {string} message
   */
  info(message: string) {
    this.open(SnackBarStatus.INFO, message);
  }

  /**
   * opens an error snackbar
   * @param {string} message
   */
  error(message: string) {
    this.open(SnackBarStatus.ERROR, message);
  }

  /**
   * opens a neutral snackbar
   * @param {string} message
   */
  neutral(message: string) {
    this.open(SnackBarStatus.NEUTRAL, message);
  }

  /**
   * opens a warning snackbar
   * @param {string} message
   */
  warning(message: string) {
    this.open(SnackBarStatus.WARNING, message);
  }
}
